import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LogoComponent } from '@naybrs/ui';
import { MarketingAnalyticsService } from '../services/analytics/marketing-analytics.service';

export interface NavItem {
  name: string;
  sectionId: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [CommonModule, LogoComponent],
})
export class HeaderComponent {
  @Output() menuToggle = new EventEmitter<void>();

  // Navigation items for scroll-based navigation
  navItems: NavItem[] = [
    { name: 'Problem', sectionId: 'problem' },
    { name: 'Product', sectionId: 'product' },
    { name: 'Intelligence', sectionId: 'intelligence' },
    { name: 'Different', sectionId: 'different' },
    { name: 'Flywheel', sectionId: 'working' },
    { name: 'Why', sectionId: 'why' },
    { name: 'Founder', sectionId: 'founder' },
  ];

  constructor(
    private router: Router,
    private readonly analytics: MarketingAnalyticsService,
  ) {}

  onMenuToggle() {
    this.menuToggle.emit();
  }

  scrollToSection(sectionId: string): void {
    void this.analytics.trackSectionClick(sectionId);
    // Navigate to home first if not already there
    if (this.router.url !== '/') {
      this.router.navigate(['/']).then(() => {
        setTimeout(() => {
          this.performScroll(sectionId);
        }, 100);
      });
    } else {
      this.performScroll(sectionId);
    }
  }

  private performScroll(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  scrollToTop(): void {
    if (this.router.url !== '/') {
      this.router.navigate(['/']);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }
}
